import moment, { Moment } from "moment-timezone";
import { ClasseAtivo } from "../enum";

interface IPatrimonio {
  codigoAtivo: string;
  classeAtivo: ClasseAtivo;
  data: Moment;
  quantidade: number;
  precoMedio: number;
  valorAplicado: number;
  fechamento: number;
  saldoBruto: number;
}

export interface IPatrimonioJson extends Omit<IPatrimonio, "data"> {
  data: string;
}

export default class Patrimonio implements IPatrimonio {
  public codigoAtivo!: string;
  public classeAtivo!: ClasseAtivo;
  public data!: Moment;
  public quantidade!: number;
  public precoMedio!: number;
  public valorAplicado!: number;
  public fechamento!: number;
  public saldoBruto!: number;
  constructor(param: IPatrimonio) {
    Object.assign(this, param);
  }
  public static fromJson(json: IPatrimonioJson): Patrimonio {
    return new Patrimonio({
      ...json,
      data: moment.tz(json.data, "America/Sao_Paulo"),
    });
  }
}
